const forms = {
  state: {
    budget: null,
    budgetDID: null,
    changeBudgetDIDCurrent: null,
    changeBudgetDIDPrevious: null,
    budgetRegister: null,
    budgetRegisterCounter: 0
  },
  mutations: {
    changeBudgetRegister(state, payload) {
      state.budgetRegister = payload;
    },
    changeBudgetRegisterCounter(state, payload) {
      state.budgetRegisterCounter = payload;
    },
    changeBudget(state, payload) {
      state.budget = payload;
    },
    changeBudgetDID(state, payload) {
      state.budgetDID = payload;
    },
    changeBudgetDIDCurrent(state, payload) {
      state.changeBudgetDIDCurrent = payload;
    },
    changeBudgetDIDPrevious(state, payload) {
      state.changeBudgetDIDPrevious = payload;
    }
  },
  actions: {
    changeBudgetRegister({ commit }, payload) {
      commit("changeBudgetRegister", payload);
    },
    changeBudgetRegisterCounter({ commit }, payload) {
      commit("changeBudgetRegisterCounter", payload);
    },
    changeBudget({ commit }, payload) {
      // commit to store
      commit("changeBudget", payload);
    },
    changeBudgetDID({ commit }, payload) {
      // commit to store
      commit("changeBudgetDID", payload);
    },
    changeBudgetDIDCurrent({ commit }, payload) {
      // commit to store
      commit("changeBudgetDIDCurrent", payload);
    }
  },
  getters: {
    getBudgetRegister: state => {
      return state.budgetRegister;
    },
    getBudgetRegisterCounter: state => {
      return state.budgetRegisterCounter;
    },
    getBudget: state => {
      return state.budget;
    },
    getBudgetDID: state => {
      return state.budgetDID;
    },
    getBudgetDIDCurrent: state => {
      return state.getBudgetDIDCurrent;
    },
    getBudgetDIDPrevious: state => {
      return state.getBudgetDIDPrevious;
    }
  }
};
// eslint-disable-next-line
export default forms;
